// @ts-nocheck
import { FC, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ExpandMore } from '@mui/icons-material';
import './select.scss';

interface CommonSelectProps {
  options: { value: string | number; label: string; class: string;}[]; // options should have value and label
  value: string | number;
  onChange: (event: SelectChangeEvent<string | number>) => void;  // This expects SelectChangeEvent
  placeholder?: string;
  disabled?: boolean;
}

const SingleSelectButton: FC<CommonSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <FormControl fullWidth className={`${disabled ? "disabled" : ""} select-button-wrapper`}>
      <Select
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        IconComponent={ExpandMore}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        className='single-select-button'
        disabled={disabled}
        MenuProps={{
          PaperProps: {
            className: 'single-select-menu',
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          disableScrollLock: true,
          disablePortal: true,
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <button className={`table-border-btn ${option.class}`}>{option.label}</button>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SingleSelectButton;
